import { gql } from '@apollo/client';

export const ALL_EDUCATION_SECTORS = gql`
  query AllEducationSectors {
    educationSectors: getEducationSectors {
      id
      name
    }
  }
`;
